<template>
  <div class="login">
    <!--登录框-->
    <div class="login-con" v-if="!this.$tool.isLogin()">
      <div class="login-title">
        <span :class="{'active' : activeNum == 0}" @click="changeLoginNane('登录')">登录</span><i> / </i>
        <span :class="{'active' : activeNum == 1}" @click="changeLoginNane('注册')">注册</span>
      </div>
      <el-form :model="loginForm"  :rules="rules" ref="loginForm"  class="demo-ruleForm">
        <el-form-item label="手机号" prop="phone" class="input-con">
          <el-input  v-model="loginForm.phone" ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code"  class="input-con">
          <div class="code-input">
            <el-input  v-model="loginForm.code"  oninput = "if(value.length > 6)value=value.slice(0,6)" ></el-input>
            <i @click="getSendcode" >{{ content }}</i>

            <!-- 登录后的 错误信息-->
            <div class="login-err" v-if="loginForm.phone != '' && loginForm.code!=''">{{ loginErr }}</div>
          </div>
        </el-form-item>
      </el-form>

      <div class="input-con agreement">
        <el-checkbox v-model="loginForm.agreement" @change="changeAgreement">
          我已阅读并同意
        </el-checkbox>
        <span>
           <a @click.stop="toLoginAgreementCom">《用户登录协议》</a>
            <a href="https://www.dell.com/learn/cn/zh/cncorp1/policies-privacy" target="_blank" style="text-decoration: none">《隐私协议》</a>
        </span>
        <div class="checkbox-err" v-if="checkboxErrShow">请勾选</div>
      </div>
      <div class="login-button" :class="{'active': loginActive}" @click="getloginAndRegister('loginForm')">{{ loginTitle }}</div>
    </div>

    <!--登录成功-->
    <div class="login-con" v-if="this.$tool.isLogin() && !this.smsHref">
      <p class="login-suss-title">恭喜您，登录成功！</p>
      <div class="login-suss-but">
        <div class="suss-but"
             v-for="(item, index) in loginSussBut"
             :class="{'active': loginSussNum == index}"
             @click="toRouterCom(index)"
        >
          {{ item }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: "login",
  data(){
    return{
      loginForm: {
        phone: '',
        code: '',
        agreement: false,
      },
      rules: {
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" },
          {
            pattern: /^((\(\d{2,3}\))|(\d{3}\-))?(1\d{10})$/,
            message: "请输入正确的手机号码"
          },
        ],
        code: [
          // { required: true, message: '验证码不能为空', trigger: 'blur' },
          { validator: this.checkCode, trigger: ['blur', 'change'] }
        ],
      },
      loginTitle: '登录',
      loginActive: false,
      loginSussBut: [], //登录成功后提示框
      loginSussNum: 0,
      codeErr: '',
      loginErr: '',
      content: '获取验证码',
      canClick: true,
      refreshData: null,
      totalTime: 60,
      // 页面级变量
      pageRecord:{
        title:'precision25周年',
        module: 'precision25周年',
        category1: '登录',
      },
      checkboxErrShow: false,
      activeNum : 0,
      action: '', //登录还是注册 register:注册; login:登录
    }
  },
  computed: mapState(['loginStyle','smsHref']),
  watch: {
    loginStyle(newVal, oldVal) {
      this.loginTitle = newVal
      if(this.loginTitle == '登录'){
        this.activeNum = 0
      }else{
        this.activeNum = 1
      }
    },
  },
  mounted() {
    //每次登录成功后就判断是否上传过  把用户userWorkId存储起来
    if(this.loginStyle == '登录'){
      this.activeNum = 0
    }else{
      this.activeNum = 1
    }
    if(this.$tool.isLogin()){
      this.getMyWorkId()
    }
  },
  methods: {
    ...mapMutations(['changeloginStyle',]),
    changeLoginNane (name){
        this.changeloginStyle(name)
    },
    getloginAndRegister(formName) {
        this.codeErr =''
        let _this = this;

        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.loginForm.agreement){
              this.loginActive = true;
              this.$api.loginAndRegister(this.loginForm.phone, this.loginForm.code)
                  .then(res=>{
                  //登录成功
                    if(res.msg=='成功'){
                      this.$tool.delLS('workId') //清空之前的workId
                      this.$tool.delLS('userWorkId') //清空我的workId
                      this.$tool.setLoginCookie(res.data);
                      this.gioAction('precision25thart_loginsuccess', {'phoneNumber':this.loginForm.phone});
                      this.clearCountDown()  //清除倒计时
                      if(this.smsHref){
                        this.$router.push(this.smsHref.split('#')[1]);
                        location.reload()
                      }else{
                        location.reload()
                      }
                    }else{
                      _this.loginErr = res.msg
                    }
                  })
                  .catch((e) => {
                    console.log(e)
                  });
            }else{
              this.loginErr = '';
              this.checkboxErrShow = true;
            }

          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    async getSendcode() {
      console.log('获取验证码点击')
      this.codeErr = '';
      console.log(this.codeErr)

      if(this.loginForm.phone != '' && this.content == "获取验证码"){
        this.content = "发送中";
        let userStatus = await this.$api.checkUnique(this.loginForm.phone);
        this.action = userStatus.data.result?'register':'login';
        this.$api.sendcode(this.loginForm.phone, this.action)
            .then(res=>{
              console.log('验证码',res)
              if(res.msg=='成功'){
                this.codeErr = '';
                this.countdowm()
              }else{
                this.codeErr = res.msg
                this.loginForm.code=''
                //处罚校验规则
              }
              this.$refs['loginForm'].validate('rules')
            })
            .catch((e) => {
              this.$alert(e.msg, {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            });
        }
      },
    changeAgreement() {
      if(this.loginForm.agreement){
        this.checkboxErrShow = false;
      }
    },
    toLoginAgreementCom() {
      this.$router.push({path:'/loginAgreement'});
    },
    toRouterCom(index) {
      this.loginSussNum = index;
      if(index == 0){
        if(this.userWorkId){
          this.$tool.setLS('workId', this.userWorkId,1)
          this.$router.push({path:'/opusInfo',  query: { id: this.userWorkId }});
        }else{
          this.$router.push({path:'/'});
        }
      }else{
        this.$router.push({path:'/'});
      }
    },
    checkCode(rule, value, callback){
      console.log(this.codeErr)
      if(this.codeErr !=''){
        callback(new Error(this.codeErr));
      }else{
        if (value === '') {
          callback(new Error('验证码不能为空'));
        }else{
          callback();
        }
      }
    },
    //点击验证码后 倒计时
    countdowm() {
      this.totalTime = 60;
      if (!this.canClick) return; //节流
      this.canClick = false;
      this.content = this.totalTime + "s";
      this.refreshData = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s";
        if (this.totalTime < 0) {
          //当倒计时小于0时清除定时器
         this.clearCountDown()
        }
      }, 1000);
    },
    //清除倒计时
    clearCountDown() {
      window.clearInterval(this.refreshData); //清除定时器
      this.content = "获取验证码";
      this.totalTime = 60;
      this.canClick = true; //这里重新开启
    },
    //是否上传过
    getMyWorkId(data) {
      let backUrl = this.$route.query?.backUrl;
      if(backUrl){
        this.$router.push({path:backUrl})
        return;
      }

      this.$api.getMyWork(this.$tool.isLogin().session, this.$tool.isLogin().OCSESSID)
          .then(res=>{
            //未上传作品
             if(res.data.work_id){
               this.loginSussBut = ['我的作品', '返回首页']
              //改变workId
              this.$tool.setLS('workId', res.data.work_id,1)
              //登录这者 workId 用来判断审核状态的显隐
              this.$tool.setLS('userWorkId', res.data.work_id,1)
              console.log( '我的作品的id',this.$tool.getLS( 'workId',1))
               this.userWorkId = res.data.work_id;
            }else{
               this.loginSussBut = ['返回首页']
             }
          })
          .catch((e) => {
          });
    },
  },

}
</script>

<style scoped lang="less">
@import "../assets/css/Login/pc";
@import "../assets/css/Login/wap";
</style>
